import { Divider, Menu, MenuItem } from "@material-ui/core";
import React, { useState } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import { CheckAuthPolicy } from "../../../../HOC/WithPermissions/WithPermissions";

import styles from "./styles.module.scss";

const HeaderSubMenu = ({ name, subMenu, permission }) => {
    const [ anchorEl, setAnchorEl ] = useState(null);

    const handleClick = (event) => {
        event.preventDefault();

        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const isActive = subMenu.map(({ path }) => path.split("/")[1].split("?")[0])
        .includes(window.location.pathname.split("/")[1]);

    if(!subMenu || !subMenu.length) {
        return null;
    }

    return (
        <CheckAuthPolicy
            withAnyPermission
            predicate={permission}
        >
            <button
                className={classnames({ [styles.active]: isActive }, "menu-item__link")}
                onClick={handleClick}
            >
                {name}
            </button>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {
                    subMenu.map(({ permission, name, path, isDividerBefore }, index) => (
                        <CheckAuthPolicy
                            key={index}
                            predicate={permission}
                        >
                            {isDividerBefore && <Divider />}

                            <MenuItem className={styles.menuItem}>
                                <Link
                                    className={classnames(styles.link, { [styles.active]: path.split("?")[0] === window.location.pathname })}
                                    to={path}
                                >
                                    {name}
                                </Link>
                            </MenuItem>
                        </CheckAuthPolicy>
                    ))
                }
            </Menu>
        </CheckAuthPolicy>
    );
};

export default HeaderSubMenu;
